import type dayjs from 'dayjs';
import cloneDeep from 'lodash/cloneDeep';

import type { QuestionValues } from '@webapp/account/src/resources/questions/questions';
import type { Col, Row } from '@webapp/account/src/resources/reports/reports';

import type { Question } from '@webapp/common/resources/entities/question';
import { initialQuestion } from '@webapp/common/resources/entities/question';
import type { QuestionType } from '@webapp/common/resources/survey';

export interface AudioInfo {
    id: number;
    mime: string;
    path: string;
    size: number;
}

export interface Answer {
    id: number;
    surveyId: number;
    authData: VkAuthData | null;
    serialNumber: number;
    lastUpdated: dayjs.Dayjs | null;
    execTime: number;
    ipAddress: string;
    url: string;
    authPhone?: string;
    alias: string;
    aliasName: string;
    audio: AudioInfo;
    referer: string;
    source: string;
    password: string;
    promocode: string;
    testScore?: number;
    testPassed?: boolean;
    testPercents?: number;
    reports: Array<AnswerReport>;

    fetch: boolean;
    linkParams: Array<{ name: string; value: string; title: string }>;
}

export interface AnswerReport extends QuestionValues {
    id: number;
    name: string;
    type: QuestionType;
    rows: Array<Row>;
    cols: Array<Col>;
    question: Question;
    comment: string;
    addInfo?: { [key: string]: any };
}

export const initialAnswer: Readonly<Answer> = {
    fetch: false,
    id: 0,
    surveyId: null,
    authData: null,
    serialNumber: 0,
    lastUpdated: null,
    execTime: 0,
    ipAddress: '',
    url: null,
    password: '',
    promocode: '',
    alias: null,
    aliasName: null,
    audio: null,
    referer: null,
    source: null,
    testScore: null,
    reports: [],
    linkParams: [],
};

export const initialAnswerReport: Readonly<AnswerReport> = {
    id: 0,
    name: '',
    value: '',
    value2: '',
    value3: '',
    type: null,
    rows: [],
    cols: [],
    comment: null,
    question: cloneDeep(initialQuestion),
    addInfo: {},
};
